// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:56:16

export default {
  "id": "astral-escape",
  "slug": "astral-escape",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/731cd1514aad4ad196d1c1ccde21b403-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/731cd1514aad4ad196d1c1ccde21b403/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Astral Escape",
      "description": "The Astronaut survived the enemy and reached the door to the mother ship but it was locked. The lock consists of several puzzles that need to be solved to unlock it.",
      "instructions": "Rotate the pieces to solve the puzzle and help the astronaut to be safe.",
      "genres": [
        "Adventure",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "airplane",
        "alien",
        "amongus",
        "astronaut"
      ]
    },
    "zh-CN": {
      "title": "星界逃脱",
      "description": "宇航员成功击败了敌人，并到达了母船的门，但门是锁着的。这把锁由几个需要解决的谜题组成，才能将其解锁。",
      "instructions": "旋转部件以解决谜题，帮助宇航员安全。",
      "genres": [
        "冒险",
        "解谜"
      ],
      "tags": [
        "1玩家",
        "飞机",
        "外星人",
        "Among Us",
        "宇航员"
      ]
    },
    "zh-TW": {
      "title": "星界逃亡",
      "description": "宇航員擊敗了敵人，並抵達了母船的大門，但大門卻是上鎖的。這個鎖由幾個需要解決的謎題組成，以解鎖它。",
      "instructions": "旋轉碎片以解開謎題，並幫助太空人安全無事。",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "飛機",
        "外星人",
        "Among Us",
        "太空人"
      ]
    },
    "zh-HK": {
      "title": "星界逃亡",
      "description": "太空人成功擊敗敵人，並抵達母船的大門，但門卻上了鎖。這把鎖由多個謎題組成，必須解開這些謎題才能打開它。",
      "instructions": "旋轉棋子以解開謎題，並幫助太空人安全無事。",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "1人玩家",
        "飛機",
        "外星人",
        "我們之中有敵人",
        "太空人"
      ]
    },
    "ja": {
      "title": "アストラル・エスケイプ",
      "description": "宇宙飛行士は敵を撃退し、母船の扉に到達したが、ドアはロックされていました。そのロックは、解除するために解き明かす必要のある複数のパズルで構成されています。",
      "instructions": "パズルを解き、宇宙飛行士を安全に導くためにピースを回転させます。",
      "genres": [
        "アドベンチャー",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "飛行機",
        "エイリアン",
        "アモンアミューズ",
        "宇宙飛行士"
      ]
    },
    "ko": {
      "title": "성신탈출",
      "description": "우주인은 적을 이겨내고 어머니선의 문에 도달했지만 문이 잠겨있었습니다. 문은 여러 가지 퍼즐을 해결해야 열리는 것입니다.",
      "instructions": "모자이크 조각을 돌려 퍼즐을 해결하고 우주인을 안전하게 도와주세요.",
      "genres": [
        "모험",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "비행기",
        "외계인",
        "아머너스",
        "우주인"
      ]
    },
    "fr": {
      "title": "Évasion Astrale",
      "description": "L'astronaute a survécu à l'ennemi et a atteint la porte de la navette-mère, mais elle était verrouillée. Le verrou consiste en plusieurs énigmes qui doivent être résolues pour le déverrouiller.",
      "instructions": "Tournez les pièces pour résoudre le puzzle et aider l'astronaute à être en sécurité.",
      "genres": [
        "Aventure",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "avion",
        "alien",
        "Among Us",
        "astronaute"
      ]
    }
  }
};
